import {
    combineReducers,
    type Reducer,
    type AnyAction,
    type CombinedState,
    type ReducersMapObject,
    type StateFromReducersMapObject,
    type ActionFromReducersMapObject
} from 'redux';

export class ReducerService<T extends ReducersMapObject<any, any>> {
    private reducers: T;
    public combinedReducer: Reducer<CombinedState<StateFromReducersMapObject<T>>, ActionFromReducersMapObject<T>>;

    constructor(initialReducers: T) {
        this.reducers = { ...initialReducers };
        this.combinedReducer = combineReducers<T>(this.reducers);
    }

    add = <TState, TAction extends AnyAction>(
        key: string,
        reducer: (uniqueId: string) => Reducer<TState, TAction>,
        uniqueId: string
    ) => {
        if (!key || this.reducers[key]) {
            return this.combinedReducer;
        }

        this.reducers[key as keyof T] = reducer(uniqueId) as T[keyof T];

        return this.combinedReducer = combineReducers<T>(this.reducers);
    };

    remove = (key: string) => {
        if (!key || !this.reducers[key]) {
            return this.combinedReducer;
        }

        delete this.reducers[key];

        return this.combinedReducer = combineReducers<T>(this.reducers);
    };
}
